const INS_VEHICLE = 1
const INS_WORK = 2
const INS_TASK = 3
const INS_COMPANY = 4
const INS_BRIDGE = 5
const INS_CULVERT = 6
const INS_HARJA_BRIDGE = 7
const INS_USER = 8


export const inspectionHelper = {
    data: function () {
        return {
            resultSkip: 1,
            resultOk: 2,
            resultDefect: 3,
            resultBan: 4,
            INS_VEHICLE,
            INS_WORK,
            INS_TASK,
            INS_COMPANY,
            INS_BRIDGE,
            INS_CULVERT,
            INS_HARJA_BRIDGE,
            INS_USER
        }
    },



    methods: {
        newInspectable: function () {
            return {
                id: -1,
                name: ''
            }
        },

        jsonToInspectable: function (inspectable) {
            return JSON.parse(JSON.stringify(inspectable))
        },

        newInspection: function () {
            return {
                id: -1,
                name: '',
                vehicle_type: '',
                type: '',
                inspectables: []
            }
        },

        jsonToInspection: function (inspection) {
            return JSON.parse(JSON.stringify(inspection))
        },

        getInspectionTypeName: function (inspectionType) {
            switch (inspectionType) {
                case this.INS_VEHICLE:
                    return this.$t('inspection_template.type.vehicle')
                case this.INS_WORK:
                    return this.$t('inspection_template.type.work')
                case this.INS_TASK:
                    return this.$t('inspection_template.type.task')
                case this.INS_COMPANY:
                    return this.$t('inspection_template.type.company')
                case INS_BRIDGE:
                    return this.$t('inspection_template.type.bridge')
                case INS_CULVERT:
                    return this.$t('inspection_template.type.culvert')
                case INS_HARJA_BRIDGE:
                    return this.$t('inspection_template.type.harja_bridge')
                case INS_USER:
                    return this.$t('inspection_template.type.user')
            }
        },

        getInspectionFrequency: function (frequency) {
            switch (frequency) {
                case 1:
                    return this.$t('inspection_template.frequency.weekly')
                case 2:
                    return this.$t('inspection_template.frequency.monthly')
                case 3:
                    return this.$t('inspection_template.frequency.annually')
                case 4:
                    return this.$t('inspection_template.frequency.deployment')
                case 5:
                    return this.$t('inspection_template.frequency.daily')
                case 6:
                    return this.$t('inspection_template.frequency.other')
                case 7:
                    return this.$t('inspection_template.frequency.once')
            }
        },

        getInspector(user) {
            return user.last_name + ', ' + user.first_name
        },

        getInspectionTarget(result) {
            if (result.vehicle) {
                const v = result.vehicle
                let target = v.license_plate + ' - ' + v.make + ' ' + v.vehicle_model
                if (v.company) target += ' / ' + v.company.name
                return target
            }
            if (result.order) {
                return result.order.task_type.name + ' (' + result.order.contract.name + ')'
            }
            if (result.contract) {
                let str = result.contract.name
                return result.contract.contract_number ? str + ' ' + result.contract.contract_number : str
            }
            if (result.area) {
                return result.area.name
            }
            if (result.inspected_company) {
                return result.inspected_company.name
            }
            if (result.bridge_id) {
                return this.$t('ins_report.bridge') + "-" + result.bridge_id
            }
            if (result.culvert_id) {
                return this.$t('ins_report.culvert') + "-" + result.culvert_id
            }
        },

        getInspectionResultName: function (resultType) {
            switch (resultType) {
                case 1:
                    return this.$t('inspection.options.not_tested')
                case 2:
                    return this.$t('inspection.options.okay')
                case 3:
                    return this.$t('inspection.options.defects')
                case 4:
                    return this.$t('inspection.options.ban')
            }
        }
    }
}
